import { render } from "./protectionPlansCard.vue?vue&type=template&id=42731a0b"
import script from "./protectionPlansCard.vue?vue&type=script&lang=js"
export * from "./protectionPlansCard.vue?vue&type=script&lang=js"

import "./protectionPlansCard.vue?vue&type=style&index=0&id=42731a0b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__